import { Directive, effect, input, signal } from '@angular/core'

import { css } from '@emotion/css'

import { TemplateConfigInterfaceFromCollection } from '@flowx/core-sdk'
import { computePosition } from '@flowx/core-theme'

@Directive({
  selector: '[flxPositionStyle]',
  host: {
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxPositionStyleDirective {
  flxPositionStyle = input.required<TemplateConfigInterfaceFromCollection>()

  styleClassName = signal<string>('')

  constructor() {
    effect(() => {
      const className = computePosition(this.flxPositionStyle().displayOptions.style.position)
      this.styleClassName.set(css(className))
    })
  }
}
